import { env } from '@/shared/config/env';

const PII_KEYS = /email|mobile|phone|emirates|iban|passport|name|salary|amount/i;

function scrub<T>(value: T): T {
  if (Array.isArray(value)) return value.map(scrub) as T;
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, PII_KEYS.test(k) ? '[redacted]' : scrub(v)])) as T;
  }
  if (typeof value === 'string') return value.replace(/784-?\d{4}-?\d{7}-?\d/g, '[eid]').replace(/AE\d{21}/g, '[iban]').replace(/\+?971\d{9}/g, '[mobile]') as T;
  return value;
}

/**
 * Error monitoring with PII scrubbing. Disabled when no DSN is configured; the SDK is only
 * downloaded when it is enabled.
 */
export async function initSentry() {
  if (!env.sentryDsn) return;
  const Sentry = await import('@sentry/react');
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.sentryEnvironment,
    release: env.release,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
    beforeSend(event) {
      if (event.request) {
        delete event.request.data;
        delete event.request.cookies;
        if (event.request.url) event.request.url = event.request.url.split('?')[0];
      }
      if (event.extra) event.extra = scrub(event.extra);
      if (event.message) event.message = scrub(event.message);
      return event;
    },
    beforeBreadcrumb(crumb) {
      if (crumb.category === 'ui.input') return null;
      if (crumb.data) crumb.data = scrub(crumb.data);
      if (crumb.message) crumb.message = scrub(crumb.message);
      return crumb;
    },
  });
}
